import { RequestTypes } from 'legacy/lut/classes/models/onboarding/Onboarding'
import { createContext } from 'react'

interface IParentRequest {
  id: number
  type: RequestTypes
}

interface IFormContext {
  requestId: number
  parentRequest: IParentRequest | null
}

const getInitialValue = (): IFormContext => ({
  requestId: -1,
  parentRequest: null,
})

const FormContext = createContext(getInitialValue())
export { FormContext }
